import React, { Fragment } from "react";
import MenuNavHeader from "components/MenuNavHeader";
import { STATE_KEYS } from "utils/constants/state";
import { useFormikContext } from "formik";
import MenuNavList from "components/FormerEditor/MenuNavList";
import get from "lodash/get";
import CommonCheckoutConfig from "./CommonCheckoutConfig";
import { EDITOR_MODE } from "utils/constants/editor";
import {
  CHECKOUT_SETTINGS_INTENT,
  SET_CHECKOUT_COMMON_GUIDANCE
} from "utils/constants/checkout";
import PlayVideoTrigger from "components/PlayVideoTrigger";
import { COMMAND_CONTENT_ID } from "components/CommandPalette/constants";

const CheckoutSettings = (props) => {
  const { values, setFieldValue } = useFormikContext();

  const intent = get(values, STATE_KEYS.EDITOR.MENU_SUB_INTENT);

  const activeInspectMode =
    get(values, STATE_KEYS.EDITOR.MODE) === EDITOR_MODE.INSPECT;

  const setModeAndIntent = (updatedIntent) => {
    if (activeInspectMode) {
      setFieldValue(STATE_KEYS.EDITOR.MODE, EDITOR_MODE.USE);
    }
    setFieldValue(STATE_KEYS.EDITOR.MENU_SUB_INTENT, updatedIntent);
  };

  const MENU_ITEMS_CONFIG = [
    {
      label: "Common",
      description: SET_CHECKOUT_COMMON_GUIDANCE,
      onClick: () => setModeAndIntent(CHECKOUT_SETTINGS_INTENT.SET_COMMON)
    }
  ];
  let content;

  if (!intent) {
    content = (
      <Fragment>
        <MenuNavHeader label="Settings" />
        <MenuNavList config={MENU_ITEMS_CONFIG} />
      </Fragment>
    );
  } else if (intent === CHECKOUT_SETTINGS_INTENT.SET_COMMON) {
    content = (
      <Fragment>
        <MenuNavHeader
          label="Checkout common"
          action={
            <PlayVideoTrigger id={COMMAND_CONTENT_ID.FIELDS.COMMON_CONFIG} />
          }
        />
        <CommonCheckoutConfig {...props} />
      </Fragment>
    );
  }

  return content;
};

export default CheckoutSettings;
